module.exports = __webpack_public_path__ + "img/logo.4a647fb8.png";